import React from 'react';

import { createRoot } from 'react-dom/client';
import App from './App';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { AuthProvider } from './context/AuthContext';
import { captureReferralFromUrl } from './utils/referral';

// Add this in your component file
require('react-dom');

// First-touch referral attribution: capture ?ref= from the landing URL before
// the app renders, so it survives the signup + email-verification flow.
captureReferralFromUrl();

const container = document.getElementById('app');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <AuthProvider>
    <App />

  </AuthProvider>);